import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-left.svg'


const _hoisted_1 = {
  key: 1,
  class: "items-center"
}
const _hoisted_2 = { class: "flex flex-row justify-between items-center border-b border-gray-lp-400" }
const _hoisted_3 = { class: "flex flex-row my-4" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-20px mr-4 text-black-lp-200" }, " Edit Lokasi ", -1)
const _hoisted_5 = { class: "inline-flex" }
const _hoisted_6 = {
  key: 1,
  class: "flex flex-row h-full py-6"
}
const _hoisted_7 = { class: "w-2/3 px-4 text-12px xxl:text-14px" }
const _hoisted_8 = { class: "py-3 w-3/4" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Country Code", -1)
const _hoisted_10 = { class: "flex flex-row w-3/4" }
const _hoisted_11 = { class: "py-3 w-1/2 mr-4" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Country Name", -1)
const _hoisted_13 = { class: "py-3 w-1/2" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Currency", -1)
const _hoisted_15 = { class: "flex flex-col h-full text-12px border-t border-gray-lp-400 my-6 py-6" }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Status Rute"),
  /*#__PURE__*/_createVNode("div", { class: "my-1 text-gray-lp-500 max-w-md" }, " Rute dengan status yang aktif akan digunakan sebagai lokasi awal atau destinasi pada modul route mapping ")
], -1)
const _hoisted_17 = { class: "flex flex-row text-12px xxl:text-14px items-center text-black-lp-300" }
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "toggle-knob bg-white inline-block" }, null, -1)
const _hoisted_19 = { class: "ml-4" }
const _hoisted_20 = { class: "w-1/3 px-8 text-12px xxl:text-14px border-l border-gray-lp-400" }
const _hoisted_21 = { class: "py-3" }
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Status Rute", -1)
const _hoisted_23 = { class: "my-1 text-black-lp-300" }
const _hoisted_24 = { class: "flex" }
const _hoisted_25 = { class: "py-3" }
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Tanggal Dibuat", -1)
const _hoisted_27 = { class: "my-1 text-black-lp-300" }
const _hoisted_28 = { class: "text-gray-lp-500" }
const _hoisted_29 = { class: "py-3" }
const _hoisted_30 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Terakhir Diubah", -1)
const _hoisted_31 = { class: "my-1 text-black-lp-300" }
const _hoisted_32 = { class: "text-gray-lp-500" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageDetailLazyLoad = _resolveComponent("PageDetailLazyLoad")!
  const _component_button_fill = _resolveComponent("button-fill")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_PageDetailLazyLoad, {
          key: 0,
          onBack: _ctx.goBack
        }, null, 8, ["onBack"]))
      : (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode("img", {
                src: _imports_0,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
                class: "w-5 mr-3 cursor-pointer",
                alt: "back"
              }),
              _hoisted_4
            ]),
            _withDirectives(_createVNode("div", _hoisted_5, [
              _createVNode(_component_button_fill, {
                title: "Simpan",
                onClick: _ctx.onOpenSave,
                class: "px-8 bg-red-lp-300"
              }, null, 8, ["onClick"])
            ], 512), [
              [_vShow, !_ctx.isError]
            ])
          ]),
          (_ctx.isError)
            ? (_openBlock(), _createBlock(_component_ErrorMessage, {
                key: 0,
                onCancel: _ctx.handleErrorClose,
                errorType: _ctx.errorCause,
                onTryAgain: _ctx.fetchCountryData
              }, null, 8, ["onCancel", "errorType", "onTryAgain"]))
            : (_openBlock(), _createBlock("div", _hoisted_6, [
                _createVNode("div", _hoisted_7, [
                  _createVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createVNode("input", {
                      type: "text",
                      placeholder: _ctx.dataDetail().code,
                      class: 
              `py-1.5 xxl:py-3 px-4 rounded border border-gray-lp-400 focus:outline-none focus:shadow my-1 text-black-lp-300 w-full ${_ctx.isDisabled &&
                'bg-white'}`
            ,
                      disabled: _ctx.isDisabled
                    }, null, 10, ["placeholder", "disabled"])
                  ]),
                  _createVNode("div", _hoisted_10, [
                    _createVNode("div", _hoisted_11, [
                      _hoisted_12,
                      _createVNode("input", {
                        type: "text",
                        placeholder: _ctx.dataDetail().name,
                        class: 
                `py-1.5 xxl:py-3 px-4 rounded border border-gray-lp-400 focus:outline-none focus:shadow my-1 text-black-lp-300 w-full ${_ctx.isDisabled &&
                  'bg-white'}`
              ,
                        disabled: _ctx.isDisabled
                      }, null, 10, ["placeholder", "disabled"])
                    ]),
                    _createVNode("div", _hoisted_13, [
                      _hoisted_14,
                      _createVNode("input", {
                        type: "text",
                        placeholder: _ctx.dataDetail().currency,
                        class: 
                `py-1.5 xxl:py-3 px-4 rounded border border-gray-lp-400 focus:outline-none focus:shadow my-1 text-black-lp-300 w-full ${_ctx.isDisabled &&
                  'bg-white'}`
              ,
                        disabled: _ctx.isDisabled
                      }, null, 10, ["placeholder", "disabled"])
                    ])
                  ]),
                  _createVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _createVNode("div", _hoisted_17, [
                      _createVNode("div", {
                        onClick: _cache[2] || (_cache[2] = () => _ctx.onOpenRoute()),
                        class: 
                `toggle-switch inline-block cursor-pointer ${
                  _ctx.isRoute ? 'toggle-active bg-red-lp-100' : 'bg-gray-lp-200'
                }`
              
                      }, [
                        _hoisted_18
                      ], 2),
                      _createVNode("div", _hoisted_19, "Rute " + _toDisplayString(_ctx.isRoute ? "Aktif" : "Tidak Aktif"), 1)
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_20, [
                  _createVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _createVNode("div", _hoisted_23, [
                      _createVNode("div", _hoisted_24, [
                        _createVNode("div", {
                          class: 
                  `rounded-full px-2 py-0 font-medium ${
                    _ctx.isRoute ? 'bg-green-lp-300' : 'bg-red-lp-600'
                  } ${_ctx.isRoute ? 'text-green-lp-200' : 'text-red-lp-500'}`
                
                        }, _toDisplayString(_ctx.isRoute ? "Active" : "Inactive"), 3)
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_25, [
                    _hoisted_26,
                    _createVNode("div", _hoisted_27, _toDisplayString(_ctx.createdAt), 1),
                    _createVNode("div", _hoisted_28, _toDisplayString(_ctx.createdBy), 1)
                  ]),
                  _createVNode("div", _hoisted_29, [
                    _hoisted_30,
                    _createVNode("div", _hoisted_31, _toDisplayString(_ctx.updateAt), 1),
                    _createVNode("div", _hoisted_32, _toDisplayString(_ctx.updateBy), 1)
                  ])
                ])
              ]))
        ])),
    _withDirectives(_createVNode(_component_Modal, {
      onClose: _ctx.onCloseRoute,
      onSubmit: _ctx.changeRoute,
      title: _ctx.isRoute ? 'Non-aktifkan Lokasi' : 'Aktifkan Lokasi',
      message: 
      _ctx.isRoute
        ? 'Selama lokasi berstatus non-aktif maka lokasi tidak dapat digunakan dalam “route mapping”'
        : 'Selama lokasi berstatus aktif maka lokasi dapat digunakan dalam “route mapping”'
    ,
      image: "inactive-location",
      textSuccess: _ctx.isRoute ? 'Non-aktifkan' : 'Aktifkan',
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onClose", "onSubmit", "title", "message", "textSuccess"]), [
      [_vShow, _ctx.openRoute]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.onCloseSuccess,
      title: "Perubahan Disimpan",
      message: `Lokasi ${_ctx.dataDetail().name} berhasil diubah`,
      image: "image-modal-success",
      textSuccess: "Oke",
      class: "px-8"
    }, null, 8, ["onSubmit", "message"]), [
      [_vShow, _ctx.openSuccess]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.handlerClose,
      onClose: _ctx.handlerCancelClose,
      title: "Yakin Keluar Halaman ?",
      message: "Anda belum selesai mengisi form. Permintaan tidak akan diproses jika Anda keluar dari halaman ini.",
      image: "are-you-sure",
      textSuccess: "Keluar",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose"]), [
      [_vShow, _ctx.isEditTerminated]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx._onEdit,
      onClose: _ctx.onCloseSave,
      title: "Konfirmasi Perubahan Data Lokasi",
      message: 
      `Anda yakin akan menyimpan perubahan untuk  lokasi “${
        _ctx.dataDetail().name
      } - ${_ctx.dataDetail().code}”`
    ,
      image: "are-you-sure",
      textSuccess: "Simpan",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "message"]), [
      [_vShow, _ctx.openSave()]
    ])
  ], 64))
}